import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.403 4.111a8.014 8.014 0 0 0-5.936 14.5 1 1 0 0 1-1.131 1.649 10.015 10.015 0 0 1 7.416-18.118 1 1 0 1 1-.35 1.97m2.68-.204a1 1 0 0 1 1.385-.29 10.014 10.014 0 0 1-7.413 18.207 1 1 0 1 1 .386-1.963 8.015 8.015 0 0 0 5.932-14.57 1 1 0 0 1-.29-1.384m-2.898 4.038a1 1 0 1 0-2 0v4.425l-2.278.962a1 1 0 1 0 .778 1.842l2.889-1.219a1 1 0 0 0 .611-.921z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_duration-DBIxNY2t.js.map
